const getCriticalError = (rootState) => rootState.criticalError;

export default getCriticalError;
